import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "onClick", "onMouseEnter", "onMouseLeave", "id", "role", "disabled", "title", "tabIndex", "aria-hidden", "aria-describedby", "aria-description", "aria-label", "children"];
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { useAbstractTextElementContext } from '../AbstractTextElement/AbstractTextElementProvider';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
// The `as` prop will determine the tag name of the element.
const StyledTag = styled.span.withConfig({
  displayName: "AbstractElement__StyledTag",
  componentId: "sc-3da3q7-0"
})(({
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge($styleOverrides, $cssStyles);
});
export const AbstractElement = _ref => {
  var _abstractTextElementC;
  let {
      tagName = 'span',
      onClick,
      onMouseEnter,
      onMouseLeave,
      id,
      role,
      disabled,
      title,
      tabIndex,
      'aria-hidden': ariaHidden,
      'aria-describedby': ariaDescribedby,
      'aria-description': ariaDescription,
      'aria-label': ariaLabel,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const abstractTextElementContext = useAbstractTextElementContext();
  return /*#__PURE__*/_jsx(StyledTag, Object.assign({}, domProps, {
    as: tagName,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    id: id,
    role: role,
    disabled: disabled,
    title: title,
    tabIndex: tabIndex,
    "aria-hidden": ariaHidden,
    "aria-describedby": ariaDescribedby,
    "aria-description": ariaDescription,
    "aria-label": ariaLabel,
    $cssStyles: cssStyles,
    $styleOverrides: (_abstractTextElementC = abstractTextElementContext === null || abstractTextElementContext === void 0 ? void 0 : abstractTextElementContext.abstractElementStylesOverrides) !== null && _abstractTextElementC !== void 0 ? _abstractTextElementC : {},
    children: children
  }));
};